import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/merchandiser/";

export default class MerchandiserApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getMerchandisers(params) {
    return await request.post(`${rootRoute}getMerchandisers`, {
      filter: params,
      parameters: {},
    });
  }
  async getMerchandiser(id) {
    return await request.post(`${rootRoute}getMerchandisers`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createMerchandiser(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createMerchandiser`, { data });
  }
  async deleteMerchandiser(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteMerchandiser`, { data });
  }
  async editMerchandiser(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateMerchandiser`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importMerchandiser`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getMerchandiserimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportMerchandiser`, {
      filter: filter,
      format: format
    });
  }
}
